import { BaseResponseHttp } from './commons.model';

export interface CreditValidationResponse extends BaseResponseHttp {
    response?: CreditValidation;
}

export class CreditValidation {
    hasCredit: boolean;
    exceedLimitAmount: boolean;
    hasPendingPayments: boolean;
    maxNotPayedDays: number;

    constructor() {
        this.hasCredit = false;
        this.exceedLimitAmount = false;
        this.hasPendingPayments = false;
        this.maxNotPayedDays = 0;
    }
}
